import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./admin_blog.css";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import ApiRequest from "../../helper/ApiRequest";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import "ckeditor5/ckeditor5.css";
import { BaseUrl } from "../../helper/BaseUrl";
import { toast } from "react-toastify";

const blogEditEndpoint = ApiEndpoints.adminBlogs.blogEdit;
const blogUpdateEndpoint = ApiEndpoints.adminBlogs.blogUpdate;
export default function EditBlogAdmin() {
  const navigate = useNavigate();
  const { blog_id } = useParams();

  // State variables
  const [data, setData] = useState({
    blog: {},
    categories: [],
    authors: [],
    tags: [],
  });

  const [formData, setFormData] = useState({
    name: "",
    slug: "",
    category_id: "",
    author_id: "",
    tag1: "",
    tag2: "",
    tag3: "",
    description: "",
    image: null,
    alt_image: "",
    section_image: null,
    alt_section_image: ""
  });

  const [previews, setPreviews] = useState({
    image: null,
    section_image: null,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await ApiRequest("GET", `${blogEditEndpoint}${blog_id}`,);
        setData(response);

        setFormData({
          ...response.blog,
          image: null,           
          section_image: null,
        });

        setPreviews({
          image: response.blog.image ? `${BaseUrl}${response.blog.image}` : null,
          section_image: response.blog.section_image ? `${BaseUrl}${response.blog.section_image}` : null
        });

      } catch (error) {
        console.error("Error fetching blog data:", error);
      }
    };

    fetchData();
  }, [blog_id]);

  const handleChange = (e) => {
    const { name, value, files, type } = e.target;

    if (type === "file") {
      const file = files[0];
      if (!file) return;

      // set file in form data
      setFormData(prev => ({ ...prev, [name]: file }));

      // set preview separately
      const previewUrl = URL.createObjectURL(file);
      setPreviews(prev => ({ ...prev, [name]: previewUrl }));
    } else {
      // normal text/select/textarea change
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleDescriptionChange = (event, editor) => {
    const data = editor.getData();
    setFormData(prev => ({ ...prev, description: data }));
  };

  // Submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();

    const requiredFields = [
      "name",
      "slug",
      "category_id",
      "author_id",
      "tag1",
      "tag2",
      "tag3",
      "description",
      "alt_image",
      "alt_section_image"
    ];

    const emptyField = requiredFields.find(field => {
      const value = formData[field];
      return value === "" || value === null;
    });

    if (emptyField) {
      toast.error(`Please fill out the ${emptyField.replace(/_/g, " ")} field`);
      return;
    }


    const fd = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      if (value !== null && value !== "") fd.append(key, value);
    });

    try {
      await ApiRequest("POST", `${blogUpdateEndpoint}${blog_id}`, fd,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      toast.success("Blog updated successfully");
      navigate("/admin/blog");
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  return (
    <>
      <div className="header-add-category">
        <h5>Edit Blogs</h5>
      </div>
      <div className="add-blog-content">
        <form onSubmit={handleSubmit}>
          <div className="row">
            {/* Title Input */}
            <div className="col-md-12">
              <label>Title:</label>
              <input required type="text" value={formData.name || ""} onChange={handleChange} name="name" className="form-control"/>
            </div>

            {/* slug Input */}
            <div className="col-md-12">
              <label>Slug:</label>
              <input required type="text" value={formData.slug || ""} onChange={handleChange} name="slug" className="form-control"/>
            </div>

            {/* Category Select */}
            <div className="col-md-12">
              <div className="form-group">
                <label>Blog Category</label>
                <select required className="form-control" value={formData.category_id || ""} onChange={handleChange} name="category_id">
                  <option disabled value="">
                    Select Category
                  </option>
                  {data?.categories.map((cat, index) => (
                    <option key={index} value={cat._id}>
                      {cat.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Author Select */}
            <div className="col-md-12">
              <div className="form-group">
                <label>Author</label>
                <select required className="form-control" value={formData.author_id || ""} onChange={handleChange} name="author_id" >
                  <option disabled value="">
                    Select Author
                  </option>
                  {data?.authors.map((auth, index) => (
                    <option key={index} value={auth._id}>
                      {auth.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Tags Select */}
            <div className="col-md-4">
              <div className="form-group">
                <label>Tag 1</label>
                <select className="form-control" value={formData.tag1 || ""} onChange={handleChange} name="tag1">
                  <option disabled value="">
                    Select Tag
                  </option>
                  {data?.tags.map((tag1, index) => (
                    <option key={index} value={tag1._id}>
                      {tag1.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label>Tag 2</label>
                <select className="form-control" value={formData.tag2 || ""} onChange={handleChange} name="tag2">
                  <option disabled value="">
                    Select Tag
                  </option>
                  {data?.tags.map((tag2, index) => (
                    <option key={index} value={tag2._id}>
                      {tag2.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label>Tag 3</label>
                <select className="form-control" value={formData.tag3 || ""} onChange={handleChange} name="tag3">
                  <option disabled value="">
                    Select Tag
                  </option>
                  {data?.tags.map((tag3, index) => (
                    <option key={index} value={tag3._id}>
                      {tag3.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Description Editor */}
            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="des1">Description</label>
                <CKEditor required onChange={handleDescriptionChange} editor={ClassicEditor}
                  data={formData.description} config={{ toolbar: [ "heading", "|", "bold", "italic", "link", "bulletedList", "numberedList", "blockQuote", "undo", "redo",],}}/>
              </div>
            </div>

            {/* Image Upload */}
            <div className="col-md-12">
              <div className="form-group">
                <label >Image(558 × 375 px)</label>
                <input type="file" className="form-control" name="image" onChange={handleChange}/>
               
                {previews.image && (
                  <img src={previews.image} alt="Preview" style={{ width: "100px", marginTop: "5px" }} />
                )}
              </div>
            </div>

            <div className="col-md-12">
              <div className="form-group">
                <label >Image Alt*</label>
                <input value={formData.alt_image} required type="text" className="form-control" name="alt_image" onChange={handleChange}/>
              </div>
            </div>

            {/* Banner Image Upload */}
            <div className="col-md-12">
              <div className="form-group">
                <label>Banner Image(1116 x 416 px)</label>
                <input type="file" className="form-control" name="section_image" onChange={handleChange}/>

                {previews.section_image && (
                  <img src={previews.section_image} alt="Banner Preview" style={{ width: "100px", marginTop: "5px" }}/>
                )}
              </div>
            </div>

            <div className="col-md-12">
              <div className="form-group">
                <label>Banner Image Alt*</label>
                <input value={formData.alt_section_image} required type="text" className="form-control" name="alt_section_image" onChange={handleChange}/>
              </div>
            </div>

            {/* Submit Button */}
            <div className="submit-formbtn">
              <button type="submit" className="default-btn">
                Submit
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}
